import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatPaginator } from "@angular/material/paginator";
// import { MatSnackBarConfig, MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { LosService } from "../../_LOS/services/los.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { LmsService } from "../../_Lms/services/lms.service";
import * as moment from "moment";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
declare var $: any;
import { constantUrl } from "../../Shared/constantUrl";
import { DialogService } from "../../Shared/dialog.service";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";

@Component({
  selector: "app-quickloan-foir-view",
  templateUrl: "./quickloan-foir-view.component.html",
  styleUrls: ["./quickloan-foir-view.component.scss"],
  standalone: false
})
export class QuickloanFOIRViewComponent implements OnInit {
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  configSuccess1: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  configSuccess2: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  totalMonthlyExpense: number = 0;
  showSpinner: boolean = false;
  currentUser: any;
  loading: boolean = false;
  customerData: any = {};
  IncExpData: any;
  CustomerId: any;
  IncomeTypeDropdown: any = [];
  customerProfileBaseUrl: any = constantUrl.customerProfilePicUrl;
  @Input() Revert_IsEdit: any;
  isIncomeEdit: boolean = false;
  IncomeModel: any = [];
  ExpenseModel: any = [];
  ObligationModel: any = [];
  // AllowExtension: string[] = ["pdf", "zip"];
  resultforcondition: any = [];
  isEnabled: boolean = false;
  dialogreturn: any;
  CustomerName: any;
  RemarksFoir: any;

  displayedFoirColumns: any = [];
  dataSourceFoir: any;
  incomeExpenxeType: any = "Income";
  Nature: any = "";
  Institution_From: any;
  Amount: any;
  Remarks: any;
  Doc_Details: any = { Doc_FileName: "" };

  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() isNew: boolean;

  totalCalculator: any = { total: 0.0 };
  totalCalculator1: any = { total: 0.0, expAmount: 0.0 };
  totalCalculatorObligation: any = { total: 0.0 };
  TotalObligation: any;
  today: Date = new Date();

  Margin: any;
  Eligibility: any;
  EMIEligibility: number = 0;
  CurrentEmi: any;
  SavingAmount: number = 0;

  IsEdit: boolean = false;
  IsDisabled: boolean = false;
  @Input() Status: any;
  @Input() ProcessName: any;

  //BtnAddView: any = 'Fill';

  // FOIRItems: { IsEligible: boolean; FOIR_Amount: number }[] = [];
  docBaseUrl: any = constantUrl.customerProfilePicUrl;
  AllowExtension: any = constantUrl.AllowExtension;
  totalFOIR: number = 0;
  totalFOIRExpense: number = 0;

  resultItem1CurrentEmi: number = 0;
  isCheckboxChecked: boolean = false;
  resultItem1FoirId: any = 0;
  isEligibleVariable: any;
  totalMonthlyExpenseCalculated: { total: number };
  totalMonthlyIncomeCalculated: { total: number };
  totalMonthlyObligationCalculated: { total: number };
  CustomerList: any = 0;
  dataSourceFoirCart: any;

  bankNameFoirCart: any = "other";
  fileNoFoirCart: any;
  productTypeFoirCart: any = "salariedLoan";
  passwordFoirCart: any;
  fileNameAttachment: any;

  constructor(
    private _Route: Router,
    private dialog: DialogService,
    private dataSharingService: DataSharingService,

    private snackBar: MatSnackBar,
    private _MasterService: MasterService,
    private losService: LosService,
    private LmsService: LmsService,
    private _EncrDecrService: EncrDecrService,
    private _QuickLoanService: QuickLoanService
  ) { }

  ngOnInit(): void {
    // this.updateFOIR();
    this.get_IncomeDropdownList();
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next(this.ProcessName);

    this.QuickLoan_Get_FOIR_Detail();
    // this.onChangeEligibilityRatio();
    this.fileNoFoirCart = this.loanSummary.ApplicationNo;
    console.log("loan summary", this.loanSummary.ApplicationNo);
    console.log("this.fileNoFoirCart", this.fileNoFoirCart);

    this.onChangeEligibilityRatio();
    this.QuickLoan_Save_PageProcess("FOIR", this.PageData.MM_Id);
    this.QuickLoan_Save_PageProcess("Income Info", 4);

    this.displayedFoirColumns = [
      "Customer_Id",
      "CustomerName",
      "Type",
      "Amount",
      "Inc_and_Exp_Type",
      "Inc_and_Exp_From",
      "Remarks",
      "Doc_FileName",
      "Delete",
    ];
  }

  validateEligibility(event) {
    const value = event.target.value;
    if (value > 100) {
      this.Eligibility = 100;
      const customMessage = "Invalid Input!!!";
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: customMessage,
        ...this.configSuccess2,
      });
    }
  }

  QuickLoan_Get_FOIR_Detail() {
    this.IncomeModel = [];
    this.ExpenseModel = [];
    this.ObligationModel = [];
    this._QuickLoanService
      .QuickLoan_Get_FOIR_Detail({ LoanId: this.loanSummary.LoanId })
      .subscribe((result: any) => {
        console.log("FOIR LIST", result.Item1[0]);

        //this.isEligibleVariable = result.Item2[0].IsEligible;
        //console.log("is Eligible", this.isEligibleVariable);
        // console.log(typeof result);
        // var resultItem1 = result.item1[2];
        // console.log("Result .for item1", resultItem1);
        // console.log("Length", result.Item1.length);

        if (result.Item1 && result.Item1.length > 0) {
          // console.log("if started", result?.Item1[0]?.CurrentEMI);

          this.resultItem1CurrentEmi = result?.Item1[0]?.CurrentEMI;
          this.Eligibility =
            result?.Item1[0]?.Eligibility_Percentage == 0
              ? 0
              : result?.Item1[0]?.Eligibility_Percentage;
          this.CurrentEmi = this.resultItem1CurrentEmi;

          this.resultItem1FoirId = result?.Item1[0]?.FOIRId;

          if (this.resultItem1FoirId > 0) {
            this.IsEdit = true;
          }

          console.log("resultItem1FoirId", this.resultItem1FoirId);
        }

        if (result.Item2 && result.Item2.length > 0) {
          this.IncomeModel = result.Item2.filter((x) => x.Type == "Income");
          console.log("INCOME MODEL", this.IncomeModel);
          this.ExpenseModel = result.Item2.filter((x) => x.Type == "Expense");
          this.ObligationModel = result.Item2.filter(
            (x) => x.Type == "Obligation"
          );
          this.resultforcondition = result.Item2;
          // console.log("ExpenseModel", this.ExpenseModel);
          let _total: any = 0;

          let totalMonthlyIncome: any = 0;
          this.IncomeModel.forEach((obj: any) => {
            _total =
              _total +
              parseFloat(
                obj.FOIR_Amount == undefined || obj.FOIR_Amount == ""
                  ? 0
                  : obj.FOIR_Amount
              ) || 0;
            totalMonthlyIncome =
              totalMonthlyIncome + parseFloat(obj.Amount) || 0;
          });

          this.totalCalculator = {
            total: parseFloat(_total),
          };
          this.totalMonthlyIncomeCalculated = {
            total: parseFloat(totalMonthlyIncome),
          };
          let _totalExp: any = 0;
          let totalMonthlyExpense: any = 0;
          this.ExpenseModel.forEach((obj: any) => {
            _totalExp = _totalExp + parseFloat(obj.FOIR_Amount) || 0;
            totalMonthlyExpense =
              totalMonthlyExpense + parseFloat(obj.Amount) || 0;
          });
          this.totalCalculator1 = {
            expAmount: parseFloat(_totalExp),
          };
          this.totalMonthlyExpenseCalculated = {
            total: parseFloat(totalMonthlyExpense),
          };

          let _totalObligation: any = 0;
          let totalMonthlyObligation: any = 0;
          this.ObligationModel.forEach((obj: any) => {
            _totalObligation =
              _totalObligation + parseFloat(obj.FOIR_Amount) || 0;
            totalMonthlyObligation =
              totalMonthlyObligation + parseFloat(obj.Amount) || 0;
          });
          this.totalCalculatorObligation = {
            total: parseFloat(_totalObligation),
          };
          this.TotalObligation =
            parseFloat(_totalObligation) + parseFloat(this.CurrentEmi);
          this.totalMonthlyObligationCalculated = {
            total: parseFloat(totalMonthlyObligation),
          };
          this.IsDisabled = true;
        } else {
          this.IncomeModel = [];
          this.ExpenseModel = [];
          this.ObligationModel = [];
          this.IsDisabled = false;
        }

        this.onChangeEligibilityRatio();
      });
  }

  toggleCheckbox(income, expense, Obligation) {
    this.isCheckboxChecked = !this.isCheckboxChecked;
    if (income != "" && income.IsEligible == true) {
      income.FOIR_Amount = income.Amount;
      this.onChangeIncomeAmount(income);
    }
    if (income != "" && income.IsEligible == false) {
      income.FOIR_Amount = 0;
      this.onChangeIncomeAmount(income);
    }
    if (expense != "" && expense.IsEligible == true) {
      expense.FOIR_Amount = expense.Amount;
      this.onChangeExpenseAmount(expense);
    }
    if (expense != "" && expense.IsEligible == false) {
      expense.FOIR_Amount = 0;
      this.onChangeExpenseAmount(expense);
    }
    if (Obligation != "" && Obligation.IsEligible == true) {
      Obligation.FOIR_Amount = Obligation.Amount;
      this.onChangeObligationAmount(Obligation);
    }

    if (Obligation != "" && Obligation.IsEligible == false) {
      Obligation.FOIR_Amount = 0;
      this.onChangeObligationAmount(Obligation);
    }

    this.onChangeEligibilityRatio();
  }

  onChangeIncomeAmount(income) {
    console.log("Income Row", income);
    this.totalCalculator.total = 0;
    console.log("Total Consider amount", this.totalCalculator.toal);
    if (Number(income.FOIR_Amount) > Number(income.Amount)) {
      income.FOIR_Amount = income.Amount;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Foir Amount can not  greater than Monthly Amount",
        ...this.configSuccess,
      });
      // income.FOIR_Amount = 0;
    }
    let _total: any = 0;

    this.IncomeModel.forEach((obj: any) => {
      _total =
        _total +
        parseFloat(
          obj.FOIR_Amount == undefined || obj.FOIR_Amount == ""
            ? 0
            : obj.FOIR_Amount
        ) || 0;
    });

    this.totalCalculator = {
      total: parseFloat(_total),
    };

    this.onChangeEligibilityRatio();
  }

  onChangeExpenseAmount(expense) {
    let _totalExp: any = 0;

    this.ExpenseModel.forEach((obj: any) => {
      _totalExp = _totalExp + parseFloat(obj.FOIR_Amount) || 0;
    });

    this.totalCalculator1 = {
      expAmount: parseFloat(_totalExp),
    };

    console.log("Total Exp amount", this.totalCalculator1.total);
    this.onChangeEligibilityRatio();
  }

  onChangeObligationAmount(Obligation) {
    let _totalObligation: any = 0;

    this.ObligationModel.forEach((obj: any) => {
      _totalObligation = _totalObligation + parseFloat(obj.FOIR_Amount) || 0;
    });

    this.totalCalculatorObligation = {
      total: parseFloat(_totalObligation),
    };
    this.TotalObligation =
      parseFloat(_totalObligation) + parseFloat(this.CurrentEmi);

    console.log("Total Exp amount", this.totalCalculatorObligation.total);
    this.onChangeEligibilityRatio();
  }

  onChangeEligibilityRatio() {
    this.Margin = this.totalCalculator.total - this.totalCalculator1.expAmount;
    console.log("MArgin", this.Margin);
    this.EMIEligibility = (this.Margin * this.Eligibility) / 100;

    //(this.Margin * this.Eligibility ? this.Eligibility : 0) / 100;

    this.SavingAmount = 0;
    this.SavingAmount = this.EMIEligibility - this.CurrentEmi;
    console.log("Saving Amount", this.SavingAmount);
  }

  QuickLoan_Save_FOIR_Detail() {
    console.log("Save Function me aagya");
    let FoirData = [];
    var isSave = 0;
    this.IncomeModel.forEach((obj: any) => {
      if (obj.IsEligible) {
        FoirData.push({ Id: obj.Id, FOIR_Amount: obj.FOIR_Amount });
        if (obj.FOIR_Amount > 0) isSave = 1;
      }
    });

    this.ExpenseModel.forEach((obj: any) => {
      if (obj.IsEligible) {
        FoirData.push({ Id: obj.Id, FOIR_Amount: obj.FOIR_Amount });
      }
    });
    this.ObligationModel.forEach((obj: any) => {
      if (obj.IsEligible) {
        FoirData.push({ Id: obj.Id, FOIR_Amount: obj.FOIR_Amount });
      }
    });

    /* if (isSave == 1 && this.SavingAmount > 0) {*/
    console.log("Enter into if condition.");
    let _data = {
      FOIR_Detail: FoirData,
    };
    console.log("request json", JSON.stringify(_data));

    this._QuickLoanService
      .QuickLoan_Save_FOIR_Detail({
        LoginUserId: this.currentUser.userId,
        CurrentEMI: Number(this.CurrentEmi),
        Eligibility_Percentage: this.Eligibility,
        Total_Exp: this.totalCalculator1.total,
        Total_Inc: this.totalCalculator.total,
        Total_Obligation: this.totalCalculatorObligation.total,
        LoanId: this.loanSummary.LoanId,
        FOIRId: this.resultItem1FoirId,
        Remark: this.RemarksFoir,
        JSON: JSON.stringify(_data),
      })
      .subscribe((response) => {
        // console.log("Save Api Response", response);\
        if (response[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });

          this.QuickLoan_Get_FOIR_Detail();
          this.QuickLoan_Save_PageProcess("FOIR", this.PageData.MM_Id);
          this.QuickLoan_Save_PageProcess("Income Info", 4);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
      });
    //}
    //else if (isSave == 1 && this.SavingAmount <= 0) {
    //  this.dialogreturn = this.dialog
    //    .openConfirmDialog(
    //      "Are you sure you want to save the foir as your saving amount is less than 0."
    //    )
    //    .afterClosed()
    //    .subscribe((dialogResult) => {
    //      if (dialogResult == false) {
    //        return;
    //      } else {
    //        let _data = {
    //          FOIR_Detail: FoirData,
    //        };
    //        this._QuickLoanService
    //          .QuickLoan_Save_FOIR_Detail({
    //            LoginUserId: this.currentUser.userId,
    //            CurrentEMI: parseInt(this.CurrentEmi),
    //            Eligibility_Percentage: this.Eligibility,
    //            Total_Exp: this.totalCalculator1.total,
    //            Total_Inc: this.totalCalculator.total,
    //            LoanId: this.loanSummary.LoanId,
    //            FOIRId: this.resultItem1FoirId,
    //            Remark: this.RemarksFoir,
    //            JSON: JSON.stringify(_data),
    //          })
    //          .subscribe((response) => {
    //            // console.log("Save Api Response", response);\
    //            if (response[0].CODE == 0) {
    //              this.snackBar.openFromComponent(SnackbarComponent, {
    //                data: response[0].MSG,
    //                ...this.configSuccess,
    //              });

    //              this.QuickLoan_Get_FOIR_Detail();
    //              this.QuickLoan_Save_PageProcess("FOIR", this.PageData.MM_Id);
    //              this.QuickLoan_Save_PageProcess("Income Info", 4);
    //            } else {
    //              this.snackBar.openFromComponent(SnackbarComponent, {
    //                data: response[0].MSG,
    //                ...this.configSuccess,
    //              });
    //            }
    //          });
    //      }
    //    });
    //} else {
    //  //  this.QuickLoan_Save_FOIR_Detail();
    //  const customMessage =
    //    "Please consider atleast one income or FOIR Amount Greater than 0.";
    //  this.snackBar.openFromComponent(SnackbarComponent, {
    //    data: customMessage,
    //    ...this.configSuccess1,
    //  });
    //  ///this.QuickLoan_Save_FOIR_Detail();
    //}
  }

  onEditFoirAmount() {
    this.IsEdit = false;
  }
  QuickLoan_Save_PageProcess(PageType, PageId) {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: PageType,
        ProductId: this.loanSummary.ProductId,
        Loan_Id: this.loanSummary.LoanId,
        Process_Id: this.Processid,
        Page_Id: PageId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => {
        //return res[0].CODE;
      });
  }

  fileChangeListenerForIncome(data: any, files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB) {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      data.Doc_FileName = "";
      delete data.DocData;
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Please upload correct file`,
        ...this.configSuccess,
      });
      files.value = "";
      data.Doc_FileName = "";
      delete data.DocData;
      return;
    }

    let reader = new FileReader();
    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    data.Doc_FileName = _pre + "_" + sanitizedFileName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      data.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }
  removeFileIncome(data: any, input: any) {
    input.value = "";
    data.Doc_FileName = "";
    delete data.DocData;
  }

  fileChangeListenerExpense(data: any, files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB) {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      data.Doc_FileName = "";
      delete data.DocData;
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Please upload correct file`,
        ...this.configSuccess,
      });
      files.value = "";
      data.Doc_FileName = "";
      delete data.DocData;
      return;
    }

    let reader = new FileReader();
    let _pre = new Date().getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    data.Doc_FileName = _pre + "_" + sanitizedFileName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      data.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }
  removeFileExpense(data: any, input: any) {
    input.value = "";
    data.Doc_FileName = "";
    delete data.DocData;
  }

  openAddEditFoirModel() {
    this._QuickLoanService
      .QuickLoan_Get_Inc_Exp_By_LoginUser({
        LoanId: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((resultt: any) => {
        console.log("Result of Add Button API CALL", resultt);
        this.dataSourceFoir = new MatTableDataSource(
          JSON.parse(JSON.stringify(resultt))
        );
      });

    $("#OuterfoirIncomeExpenseModel").modal("show");
    $("#OuterfoirIncomeExpenseModel").css("z-index", "1050");
  }

  deleteFoir(row) {
    this.dialogreturn = this.dialog.openConfirmDialog(
      "Are you sure you want to delete?"
    );
    this.dialogreturn.afterClosed().subscribe((dialogResult) => {
      if (dialogResult == true) {
        this._QuickLoanService
          .QuickLoan_Delete_Inc_Exp_By_LoginUser({
            LoanId: this.loanSummary.LoanId,
            Id: row.Id,
          })
          .subscribe((response) => {
            if (response[0].CODE == 0) {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
              this.openAddEditFoirModel();
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: response[0].MSG,
                ...this.configSuccess,
              });
            }
          });
      }
    });
  }
  onCloseAddEditFoirModel() {
    $("#OuterfoirIncomeExpenseModel").modal("hide");
  }

  openInnerAddEditFoirModel() {
    $("#InnerAddEditFoirModel").modal("show");
    $("#InnerAddEditFoirModel").css("z-index", "1100");

    this.getCustomerList();

    this.onCloseAddEditFoirModel();
  }

  OnCloseInnerModel() {
    $("#InnerAddEditFoirModel").modal("hide");
  }

  getCustomerList() {
    this.LmsService.GetCustomerByLoanNo({
      Loan_Id: this.loanSummary.LoanId,
    }).subscribe((result) => {
      this.CustomerList = JSON.parse(JSON.stringify(result));
    });
  }

  get_IncomeDropdownList() {
    this._MasterService
      .GetCustomer_Profile_Master_For_Dropdown({
        Type: "Nature of work",
        P_ID: 0,
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          this.IncomeTypeDropdown = res;
          console.log("Income type dropdown", this.IncomeTypeDropdown);
        }
      });
  }

  onSaveFoir() {
    interface LoanRequest {
      Customer_Id: number;
      Loan_Id: number;
      Type: string;
      Amount: number;

      Nature: string;
      Institution_From: string;
      Total_Amount: number;
      Remarks: string;
      Doc_FileName: string;
      LoginUserId: number;
      InFoir: number;
    }

    const loanRequest: LoanRequest = {
      Customer_Id: this.CustomerName,
      Loan_Id: this.loanSummary.LoanId,
      Type: this.incomeExpenxeType,
      Amount: this.Amount,
      Nature: this.Nature,
      Institution_From: this.Institution_From,
      Total_Amount: this.Amount * 12,
      Remarks: this.Remarks,
      Doc_FileName: this.Doc_Details.Doc_FileName,
      LoginUserId: this.currentUser.userId,
      InFoir: 1,
    };

    let _data = {
      Income_and_Expenses: loanRequest,
    };
    console.log("loanRequest", loanRequest);
    // const jsonLoanRequest = JSON.stringify(loanRequest);

    this._QuickLoanService
      .QuickLoan_Save_Income_Expenses_Detail({
        JSON: JSON.stringify(_data),
      })
      .subscribe((res: any) => {
        console.log(res);
        if (res[0].CODE >= 0) {
          var docs = [];
          docs.push(this.Doc_Details);
          console.log("docs", docs);
          this.uploadIncomeDocs(this.CustomerName, docs);

          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });

          this.QuickLoan_Get_FOIR_Detail();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
    this.OnCloseInnerModel();
  }
  uploadIncomeDocs(id: any, data: any[]) {
    data.forEach((obj: any) => {
      if (obj.DocData) {
        this.losService
          .UploadCustomerDoc({
            CustomerID: id,
            DocName: obj.Doc_FileName,
            DocData: obj.DocData,
          })
          .subscribe((res: any) => { });
      }
    });
  }
  removeFile1(data: any, input: any) {
    input.value = "";
    data.Doc_FileName = "";
    delete data.DocData;
  }
  fileChangeListener(data: any, files: any) {
    let Ext = files[0].name.split(".").pop().toLowerCase();
    var FileSize = Math.floor(files[0].size / Math.pow(1024, 1));

    if (FileSize > this.currentUser.UploadMaxSize_In_KB) {
      var Msg = `Upload file size should be less than or equal to ${this.currentUser.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      files.value = "";
      data.Doc_FileName = "";
      delete data.DocData;
      return;
    }

    if (!this.AllowExtension.includes(Ext)) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Please upload correct file`,
        ...this.configSuccess,
      });
      files.value = "";
      data.Doc_FileName = "";
      delete data.DocData;
      return;
    }

    let reader = new FileReader();
    let _pre = this.today.getTime();
    let sanitizedFileName = this._MasterService.sanitizeFileName(files[0].name);
    data.Doc_FileName = _pre + "_" + sanitizedFileName;
    reader.readAsDataURL(files[0]);
    reader.onload = function () {
      data.DocData = reader.result.toString().split(";base64,").pop();
      return;
    };
  }


}
